import { useLocation } from "react-router-dom";
import { ClaimDetailPage } from "../ClaimDetailPage";
import type { ClaimActionPreset } from "../../lib/claimWorkflowActions";

const REPORT_META: Record<
  string,
  { backTo: string; backLabel: string; actionPreset: ClaimActionPreset; readOnly?: boolean }
> = {
  recovered: { backTo: "/reports/recovered", backLabel: "Value Recovered", actionPreset: "recovered" },
  potential: { backTo: "/reports/potential", backLabel: "Potential Claims", actionPreset: "review" },
  "in-progress": { backTo: "/reports/in-progress", backLabel: "In Progress Claims", actionPreset: "pipeline" },
  rejected: { backTo: "/popup/rejected", backLabel: "Rejected Claims", actionPreset: "review" },
};

interface PortfolioBackState {
  backTo?: string;
  backLabel?: string;
}

function reportKeyFromPath(pathname: string): string {
  if (pathname.includes("/recovered")) return "recovered";
  if (pathname.includes("/in-progress")) return "in-progress";
  if (pathname.includes("/rejected")) return "rejected";
  return "potential";
}

export function ReportClaimDetailPage() {
  const { pathname, state } = useLocation();
  const key = reportKeyFromPath(pathname);
  const meta = REPORT_META[key];
  const portfolioBack = (state as PortfolioBackState | null) ?? {};
  // Inside the claims popup the list to go back to is the popup's own list
  // (no sidebar there), not the full-app report page.
  const inPopup = pathname.startsWith("/popup/");
  const backTo = inPopup ? `/popup/${key}` : meta.backTo;

  return (
    <ClaimDetailPage
      backTo={portfolioBack.backTo ?? backTo}
      backLabel={portfolioBack.backLabel ?? meta.backLabel}
      actionPreset={meta.actionPreset}
      readOnly={meta.readOnly}
    />
  );
}
